import { Injectable} from 'ng-metadata/core';
const  isMatch  = require('lodash/isMatch');

@Injectable()
export class MappingTablesCache {

    private cachedTableNames = {
        AUTO_COMPLETE_CONFIG:       'Auto Complete Configuration',
        RECENT_SEARCHES_CONFIGURATION:'Recent Searches Configuration',
        HOLDINGS_RECORD_CONFIG:     'Holdings Record Configuration',
        BROWSE_LISTS:               'Browse Lists',
        SORT_FIELDS_CONFIG:         'sort_fields_config',
        CITATION_STYLES:            'Citation styles',
        CITATION_STYLE_LANGUAGE:    'Citation Style Language',
        PERSONAL_SETTING_FIELDS:    'Personal Setting Fields',
        PERSONAL_DETAILS_CONFIGURATION: 'Personal Details Configuration',
        LOANS_BRIEF_DISPLAY:        'Loans Brief Display',
        REQUESTS_BRIEF_DISPLAY:     'Requests Brief Display',
        FINES_BRIEF_DISPLAY:        'Fines Brief Display',
        AUTHENTICATION_SERVICE:     'Authentication Service',
        LOANS_DETAILED_DISPLAY:     'Loans Detailed Display',
        MAIN_MENU_URLS_FOR_THE_NEW_UI: 'Main Menu URLs for the New UI',
        LOCATION_ITEM_CONTENT:      'Location Item content',
        ITEMS_BRIEF_DISPLAY:        'Items Brief Display',
        GENERAL_CONF:				'General Configuration',
        LIBRARY_LEVEL_LIST:         'Library Level List',
        /* Get It - Request Services */
        HOLD_OPTIONAL_REQUEST_PARAMETERS: 'Hold Optional Request Parameters',
        PHOTOCOPY_OPTIONAL_REQUEST_PARAMETERS: 'Photocopy Optional Request Parameters',
        CALL_SLIP_OPTIONAL_REQUEST_PARAMETERS: 'CallSlip Optional Request Parameters',
        UBREQUEST_OPTIONAL_REQUEST_PARAMETERS: 'UBRequest Optional Request Parameters',
        RECALL_OPTIONAL_REQUEST_PARAMETERS: 'Recall Optional Request Parameters',
        ILL_OPTIONAL_REQUEST_PARAMETERS: 'ILL Optional Request Parameters',
        UB_OPTIONAL_REQUEST_PARAMETERS: 'UBRequest Optional Request Parameters',
        DIGITIZATION_OPTIONAL_REQUEST_PARAMETERS: 'Digitization Optional Request Parameters',
        RESOURCE_SHARING_REQUEST_PARAMETERS: 'Resource Sharing Request Parameters',
        HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS: 'Request (Hold and Booking) Optional Parameters',
        PURCHASE_REQUEST_OPTIONAL_PARAMETERS:'Purchase Request Optional Parameters',
        EXPORT_RIS_ENCODINGS:'Export RIS encodings',
        GETIT_LINK_1_CONFIGURATION:'GetIT! Link 1 Configuration',
        /* end Get It */
        BULK_DEFINITION: 			'Bulk Definition',
        INSTITUTIONS_BASE_URLS:		'Institution Base URLs',
        CITATION_LINKER_DEFINITIONS: 'Citation Linker Definitions',
        HYPERTEXT_LINKING_DEFINITIONS :'Hypertext Linking Definitions',
        FIELD_CHAINS_DISPLAY :'Field chains display',
        PERSONALIZE_YOUR_RESULTS_DISCIPLINES_FIELDS: 'Personalize Your Results Disciplines Fields',
        ALMA_VIEWIT_CONFIG: 'Alma ViewIt Config',
        FEATURED_NEWSPAPERS : 'Featured newspapers',
        RELATED_ITEMS: 'Related Items',
        VOICE_SEARCH_LANGUAGES: 'Voice Search Languages',
        VOICE_SEARCH_LANGUAGES_ACTIVATION: 'Voice Search Languages Activation',
        INSTITUTION_PROPERTIES: 'Institution Properties',
        VIEW_PROPERTIES :'View Properties',
        REPORT_A_PROBLEM :'Report a Problem',
        PRIMO_VE_ATOZ_LANGUAGES :'Primo VE A-Z Languages',
        AUTHORITY_SEARCH_SCOPES :'Authority Search Scopes',
        AUTHORITY_SEARCH_SORT :'Authority Search Sort',
        ACTIONS_LIST :'Actions List',
        DEI_TERM_CONFIGURATION :'DEI Term Configuration',
    };

    private MAPPING_TABLES_CACHE: Object;

    constructor(){
        this.MAPPING_TABLES_CACHE = this.getMappingTablesCache();
    }

    public getTable(tableName) {
        let tableRows = this.MAPPING_TABLES_CACHE[tableName];
        return tableRows || [];
    }

    public getTargetValue(tableName, key:IEntryKey, defaultValue = '') {
        let tableRows = this.findByProperties(tableName, key);
        if (tableRows && tableRows.length > 0) {
            let row = tableRows[0] || {target: defaultValue};
            return row.target;
        }
        return defaultValue;
    }


    public findByProperties(tableName, properties:IEntryKey) {
        let table = this.getTable(tableName) || [];
        return  table.filter(this.filterByProperties(properties));
    }


    get tables() {
        return this.cachedTableNames;
    }

    private getMappingTablesCache() {
        return window.appConfig['mapping-tables'];
    }

    private filterByProperties(properties) {
        return function (item) {
            return isMatch(item, properties);
        };
    }
}

export interface IEntryKey {
    target?		: string;
    source1?	: string;
    source2?	: string;
    source3?	: string;
    source4?	: string;
    source5?	: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/mappingTablesCache/mappingTablesCache.service.ts